import { render, staticRenderFns } from "./EventDate.vue?vue&type=template&id=e9158dfa&"
import script from "./EventDate.vue?vue&type=script&lang=js&"
export * from "./EventDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports